import React, { useState } from 'react';
import { Box as MuiBox, useTheme } from '@mui/material';
import { StarRounded, StarBorderRounded } from '@mui/icons-material';
import styled from 'styled-components';
import type { QuestionInputProps } from '../types/questionnaire';

/**
 * Shared rating input component for questionnaires
 * Handles: question_rating
 */
export const RatingInput: React.FC<QuestionInputProps> = ({
  question,
  value,
  onChange,
  disabled = false,
}) => {
  const theme = useTheme();
  const [hovered, setHovered] = useState(-1);
  const stars = 5;

  return (
    <SMuiBox>
      {Array(stars)
        .fill(0)
        .map((_, i) =>
          i < value || i <= hovered ? (
            <StarRounded
              key={i}
              fontSize="large"
              sx={{ color: theme.palette.colors.blue100 }}
              onClick={!disabled ? () => onChange(i + 1) : undefined}
              onMouseEnter={!disabled ? () => setHovered(i) : undefined}
              onMouseLeave={!disabled ? () => setHovered(-1) : undefined}
              style={{ cursor: disabled ? 'default' : 'pointer' }}
            />
          ) : (
            <StarBorderRounded
              key={i}
              fontSize="large"
              sx={{ color: theme.palette.colors.gray }}
              onClick={!disabled ? () => onChange(i + 1) : undefined}
              onMouseEnter={!disabled ? () => setHovered(i) : undefined}
              onMouseLeave={!disabled ? () => setHovered(-1) : undefined}
              style={{ cursor: disabled ? 'default' : 'pointer' }}
            />
          )
        )}
    </SMuiBox>
  );
};

const SMuiBox = styled(MuiBox)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
  }
`;
